export default "/kiban/_next/static/images/23_8L_2-4-2_withoutBH-fa187badf784f79b607349c017a7a656.png";